export const lessonsModule = {
    namespaced: true,
    state: {
        allRecordings: null,
        fetchAttempted: false,
    },
    getters: {
        allRecordings: state => state.allRecordings,
    },
    mutations: {
        SET_ALL_RECORDINGS (state, recordings) {
            state.allRecordings = recordings
        },
        SET_FETCH_ATTEMPTED (state) {
            state.fetchAttempted = true
        },
    },
    actions: {
         async fetchAllRecordings ({state, getters, commit, dispatch}) {
             if (!state.fetchAttempted) {
                 commit('SET_FETCH_ATTEMPTED', true)
                 await axios.post('/api/audio/get-recordings/' + window.location.pathname.split('/').pop())
                     .then(response => {
                         commit('SET_ALL_RECORDINGS', response.data)
                     })
                     .catch(error => {
                         console.log(error)
                     })
             }
        }
    }
}
